module.exports = __webpack_public_path__ + "img/report-sample-03@3x.63a9df94.png";